import { RefreshButton } from '@/components/core';
import { useTranslation } from 'react-i18next';
import { ORG_TEMPLATES_QUERY_KEY, type OrgTemplatesController } from './use-org-templates';
import { TemplatesSearchInput } from './templates-search-input';

interface OrgTemplatesToolbarProps {
  controller: OrgTemplatesController;
}

/** Search + refresh controls for the Org Templates tab (sits in the tab row). */
export function OrgTemplatesToolbar({ controller }: OrgTemplatesToolbarProps) {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-2">
      <TemplatesSearchInput
        value={controller.searchInput}
        onChange={controller.onSearchChange}
        placeholder={t('ORGTEMPLATES_ORG_SEARCH_PLACEHOLDER')}
      />
      <RefreshButton className="md:hidden" queryKey={ORG_TEMPLATES_QUERY_KEY} />
    </div>
  );
}
